<template>
    <div class="home">
        <!-- 订单号错误提示弹出框 -->
        <transition name="slide-fade">
            <div
                class="container error-popover"
                v-if="$store.state.amazonOrderID && showOrderError"
            >
                {{ $t('activateForm.orderIdErrPopoverMsg') }}
                <img
                    class="close-popover"
                    src="../assets/images/icon_close.png"
                    @click="changeOrder()"
                />
            </div>
        </transition>
        <!-- 订单价格低于最低价格提示弹出框 -->
        <transition name="slide-fade">
            <div class="container error-popover" v-if="showPriceError">
                {{ $t('activateForm.priceErrPopoverMsg') }}
                <img
                    class="close-popover"
                    src="../assets/images/icon_close.png"
                    @click="changeOrder()"
                />
            </div>
        </transition>
        <div class="row justify-content-between">
            <!-- 左边描述 begin -->
            <div
                class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 left-content"
            >
                <div class="show-pc">
                    <p class="main-heading">
                        {{ $t('activateExplain.title') }}
                    </p>
                    <p class="sub-heading">
                        {{ $t('activateExplain.desp') }}
                    </p>
                    <ul class="desp-list">
                        <li>
                            {{ $t('activateExplain.conditions[0]') }}
                        </li>
                        <li>
                            {{ $t('activateExplain.conditions[1]') }}
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 左边描述 end -->
            <!-- 右边基础信息 begin -->
            <div
                class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 right-content"
            >
                <p class="main-heading">
                    {{ $t('activateForm.title') }}
                </p>
                <span>{{ $t('activateForm.desp') }}</span>
                <div class="info-form">
                    <form action="">
                        <!-- 用户名 -->
                        <div class="form-group custom-input">
                            <label for="name">{{
                                $t('activateForm.name')
                            }}</label>
                            <input
                                type="text"
                                id="name"
                                :class="showNameError ? 'error-border' : ''"
                                :placeholder="
                                    $t('activateForm.namePlaceholder')
                                "
                                v-model="$store.state.name"
                                @focus="changeName()"
                            />
                            <span class="error-font" v-if="showNameError">{{
                                $t('activateForm.nameErrMsg')
                            }}</span>
                        </div>
                        <!-- 邮箱 -->
                        <div class="form-group custom-input">
                            <label for="email">{{
                                $t('activateForm.email')
                            }}</label>
                            <input
                                type="email"
                                id="email"
                                :class="showEmailError ? 'error-border' : ''"
                                :placeholder="
                                    $t('activateForm.emailPlaceholder')
                                "
                                v-model="$store.state.email"
                                @focus="changeEmail()"
                            />
                            <span class="error-font" v-if="showEmailError">{{
                                $t('activateForm.emailErrMsg')
                            }}</span>
                            <!-- <button
                                type="button"
                                class="send-code-btn"
                                @click="sendCode()"
                                :disabled="isDisabledSend"
                            >
                                <span v-if="!isDisabledSend">
                                    {{ $t('activateForm.btnSendCode') }}</span
                                >
                                <span v-else
                                    >{{
                                        $t('activateForm.countdownMsg',{countdown:countdown})
                                    }}</span
                                >
                            </button> -->
                        </div>
                        <!-- 验证码 -->
                        <!-- <div class="form-group custom-input">
                            <label for="code">{{
                                $t('activateForm.verifCode')
                            }}</label>
                            <input
                                type="text"
                                id="code"
                                :class="showCodeError ? 'error-border' : ''"
                                :placeholder="
                                    $t('activateForm.verifCodePlaceholder')
                                "
                                v-model="code"
                                @focus="changeCode()"
                            />
                            <span class="error-font" v-if="showCodeError">{{
                                $t('activateForm.verifCodeErrMsg')
                            }}</span>
                        </div> -->
                        <!-- 订单id -->
                        <div class="form-group custom-input">
                            <label for="order">{{
                                $t('activateForm.orderId')
                            }}</label>
                            <input
                                type="text"
                                id="order"
                                :class="
                                    showOrderError ||
                                    showOrderAppliedError ||
                                    showPriceError
                                        ? 'error-border'
                                        : ''
                                "
                                :placeholder="
                                    $t('activateForm.orderIdPlaceholder')
                                "
                                v-model="$store.state.amazonOrderID"
                                @focus="changeOrder()"
                            />
                            <!-- 订单号错误提示 -->
                            <span class="error-font" v-if="showOrderError">{{
                                $t('activateForm.orderIdErrMsg')
                            }}</span>
                            <!-- 该订单已领取过 错误提示 -->
                            <span
                                class="error-font"
                                v-if="showOrderAppliedError"
                                >{{
                                    $t('activateForm.orderAppliedError')
                                }}</span
                            >
                            <!-- 该SKU已领取过 错误提示 -->
                            <span
                                class="error-font"
                                v-if="showSkuAppliedError"
                                >{{ $t('activateForm.skuAppliedError') }}</span
                            >
                            <router-link
                                :to="{ path: '/guide' }"
                                class="guide-text"
                                >{{
                                    $t('activateForm.orderIdHelp')
                                }}</router-link
                            >
                        </div>
                        <div>
                            <button
                                type="button"
                                class="common-comfirm-btn custom-submit-btn"
                                @click="goChoose()"
                            >
                                {{ $t('activateForm.btnAactivate') }}
                            </button>
                        </div>
                    </form>
                </div>
                <p class="notice">
                    {{ $t('activateForm.statement') }}
                </p>
            </div>
            <!-- 右边基础信息 end -->
        </div>
        <!-- 弹框组件 -->
        <common-modal
            :isShow="isShow"
            :tipMsg="tipMsg"
            :isBtnGroup="isBtnGroup"
            @closeEvent="closeEvent()"
            @confirmEvent="confirmEvent()"
        ></common-modal>
    </div>
</template>

<script>
// @ is an alias to /src

import CommonModal from '../components/CommonModal';
export default {
    name: 'Home',
    data() {
        return {
            showNameError: false, // 是否显示姓名错误提示
            showEmailError: false, // 是否显示邮箱错误提示
            showCodeError: false, // 是否显示验证码错误提示
            showOrderError: false, // 是否显示订单号错误提示
            showOrderAppliedError: false, // 是否显示订单号已领取过提示
            showSkuAppliedError: false, // 是否显示SKU已领取过提示
            isShow: false, //  是否显示弹框
            tipMsg: this.$t('commonModal.msgContents[0]'), //  弹框提示内容
            isBtnGroup: false, //  组件显示按钮个数  true为两个  false 为一个
            code: '', // 验证码
            countdown: 30, // 发送验证码30秒倒计时
            isDisabledSend: false, // 发送验证码按钮是否可用
            showPriceError: false, // 订单低于最低价格错误提示
        };
    },
    components: {
        CommonModal,
    },
    methods: {
        // 发送验证码（暂时不添加验证码功能）
        sendCode() {
            let _this = this;
            let regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; // 邮箱正则
            if (
                this.$store.state.email == '' ||
                !regEmail.test(this.$store.state.email)
            ) {
                this.showEmailError = true;
            } else {
                // 请求api

                this.isDisabledSend = true;

                // this.$post(
                //     `/api/v1/amazon_orders/${this.$store.state.amazonOrderID}`
                // )
                //     .then((data) => {
                // 30s倒计时
                let timer = setInterval(function () {
                    _this.countdown--;
                    // console.log('countdown=',countdown);

                    if (_this.countdown <= 0) {
                        clearInterval(timer);
                        _this.countdown = 30;
                        _this.isDisabledSend = false;
                    } else {
                        _this.isDisabledSend = true;
                    }
                }, 1000);
                // })
                // .catch((err) => {
                //     console.info('err:', err);

                // });
            }
        },
        // Activate Now 按钮操作   处理完相关逻辑及 请求跳转至 choose 页面
        goChoose() {
            let regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; // 邮箱正则
            if (this.$store.state.name == '') {
                this.showNameError = true;
            } else if (
                this.$store.state.email == '' ||
                !regEmail.test(this.$store.state.email)
            ) {
                this.showEmailError = true;
            }
            // else if (this.code == '') {
            //     this.showCodeError = true;
            // }
            else if (this.$store.state.amazonOrderID == '') {
                this.showOrderError = true;
            } else {
                // 查询亚马逊订单号是否领取过
                // let amazonOrderID = '403-2723760-9247551' （领取过）// 303-6453119-8393921
                this.$get(
                    `/api/v1/amazon_orders/${this.$store.state.amazonOrderID}`
                )
                    .then((data) => {
                        // console.log(data);
                        // 初始化数据
                        this.initData();

                        let result = data.result;
                        // 查询订单号是否领取过。has_order：false 表示订单号未领取过，true 表示订单号已领取过。
                        let hasOrder = result.has_order;
                        if (hasOrder) {
                            // 已领取过
                            this.showOrderAppliedError = true;
                        } else {
                            // 未领取过
                            this.showOrderAppliedError = false;
                            this.$store.state.shopID = result.shop_id;
                            this.$store.state.amazonProductASIN =
                                result.amazon_order.asin;
                            this.$store.state.amazonProductName =
                                result.amazon_order.title;
                            this.$store.state.salesChannel =
                                result.amazon_order.sales_channel;

                            // 查询SKU是否是否领取过（限制同一种商品只能领取一次）
                            this.$post(
                                `/api/v1/amazon_orders/${this.$store.state.amazonOrderID}/valid`,
                                { email: this.$store.state.email }
                            )
                                .then((data) => {
                                    // console.log(data);
                                    let result = data.result;
                                    let errMsg = result.err_msg;

                                    // 查询SKU是否是否领取过。has_error：false 表示SKU正确且该订单号未领取过礼品，true 表示已领取过。
                                    let hasErr = result.has_error;
                                    if (hasErr) {
                                        // 该SKU已领取过
                                        if (errMsg.includes('taken')) {
                                            this.showSkuAppliedError = true;
                                            return;
                                        }

                                        // 订单是否低于最低价格
                                        if (errMsg.includes('not_enough')) {
                                            this.showPriceError = true;
                                            return;
                                        }
                                    } else {
                                        // 跳转选择礼品页
                                        this.$router.push({ path: '/choose' });
                                    }
                                })
                                .catch((err) => {
                                    console.info('err:', err);
                                    if (err.status === 404) {
                                        this.showOrderError = true;
                                        this.showOrderAppliedError = false;
                                        this.showSkuAppliedError = false;
                                    }
                                });
                        }
                    })
                    .catch((err) => {
                        console.info('err:', err);
                        if (err.status === 404) {
                            this.showOrderError = true;
                            this.showOrderAppliedError = false;
                            this.showSkuAppliedError = false;
                        }
                    });
            }
        },
        // input 聚焦 隐藏相对应的错误
        changeName() {
            this.showNameError = false;
        },
        changeEmail() {
            this.showEmailError = false;
        },
        changeCode() {
            this.showCodeError = false;
        },
        changeOrder() {
            this.showOrderError = false;
            this.showPriceError = false;
        },
        // 弹框关闭事件
        closeEvent() {
            this.isShow = false;
        },
        // 弹框确定事件
        confirmEvent() {
            this.isShow = false;
        },
        // 初始化数据(清除上一次未完成的礼物申请流程的缓存数据)
        initData() {
            this.$store.state.giftType = null;
            this.$store.state.giftID = null;
            this.$store.state.giftOrderID = null;
            this.$store.state.giftName = '';
            this.$store.state.giftImage = '';
            this.$store.state.deliverName = '';
            this.$store.state.deliverPhone = '';
            this.$store.state.deliverEmail = '';
            // this.$store.state.deliverAddress = '';
            this.$store.state.deliverStreet = '';
            this.$store.state.deliverApartment = '';
            this.$store.state.deliverCity = '';
            this.$store.state.deliverRegion = '';
            this.$store.state.deliverCountry = '';
            this.$store.state.deliverPostcode = '';
            this.$store.state.stepOne = {
                sex: null,
                age: null,
                reason: null,
                otherReason: '',
                isDisabledInput: true,
                isDisabledBtnNext: true,
            };
            this.$store.state.stepTwo = {
                starNum: null,
                commentValue: '',
                isDisabledBtnNext: true,
            };
            this.$store.commit('getGiftsList', []);
            this.$store.commit('getGiftsListScroll', []);
        },
    },
};
</script>

<style lang="scss" scoped>
.main-heading {
    font-weight: 600;
}

.left-content .main-heading {
    color: #c6a85b;
    font-size: 44px;
    line-height: 56px;
    margin-bottom: 15px;
}

.left-content .sub-heading {
    font-size: 20px;
    line-height: 26px;
}

.left-content .desp-list {
    margin-top: 150px;
    padding: 15px 18px 2px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
}

.left-content .desp-list > li {
    line-height: 23px;
    margin-bottom: 13px;
}

.right-content .main-heading {
    font-size: 30px;
    font-weight: 500;
    line-height: 38px;
    margin-bottom: 10px;
}

.home-info-form {
    margin-top: 25px;
    margin-bottom: 8px;
}

.home-info-form .custom-input {
    margin-bottom: 30px;
}

.home-info-form .error-font {
    float: right;
    margin-bottom: 10px;
}

.guide-text {
    color: #c6a85b;
    display: block;
    float: left;
    margin-bottom: 25px;
    margin-top: 10px;
}

.custom-submit-btn {
    width: 100%;
}

.right-content .notice {
    color: #a1a1a6;
    line-height: 22px;
    margin-top: 8px;
}

.error-popover {
    background: #0c0c0d;
    color: #fff;
    font-size: 18px;
    padding: 10px 50px 10px 24px;
    position: fixed;
    top: 100px;
    left: 50%;
    z-index: 14;
}

.close-popover {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

/*适配手机*/

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .home-info-form .error-font {
        float: none;
    }
    .error-popover {
        font-size: 14px;
        top: 60px;
        left: 0;
        margin: 0;
    }
}

@media (min-width: 768px) {
    .error-popover {
        margin: 0 -360px;
    }
}

@media (min-width: 992px) {
    .error-popover {
        margin: 0 -480px;
    }
}

@media (min-width: 1200px) {
    .error-popover {
        margin: 0 -570px;
    }
}

.slide-fade-enter-active {
    transition: all 0.2s ease;
}

.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}

.send-code-btn {
    border: 1px solid #c6a85b;
    color: #c6a85b;
    background: #fff;
    width: 100%;
    height: 40px;
    margin-top: 20px;

    &:hover,
    &:active,
    &:link {
        background: #c6a85b;
        color: #fff;
    }
    &[disabled] {
        color: #fff;
    }
}
</style>
